module.exports = __webpack_public_path__ + "img/05.a59d6224.jpg";